import {isPlatformServer} from '@angular/common';
import {Inject, Injectable, OnInit, PLATFORM_ID} from '@angular/core';
import {environment} from '#env';

declare const analytics: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService implements OnInit{

  isServer = true;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isServer = isPlatformServer(this.platformId);
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return;
    }

    const head = <HTMLDivElement> document.head;

    // Facebook Pixel
    if (environment.zendesk.enabled) {
      const zendesk = document.createElement('script');
      zendesk.id = 'ze-snippet';
      zendesk.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + environment.zendesk.key;

      head.appendChild(zendesk);
    }

    // segment
    if (environment.segment.enabled) {
      const segment = document.createElement('script');
      segment.innerHTML = `
!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)
window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;
analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track",
"ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){
var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};
for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}
analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;
n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];
a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
  analytics.load("${environment.segment.id}");
  //analytics.page();
  }}();
        `;

      head.appendChild(segment);
    }

    // GTM
    if (environment.ga.enabled) {
      const segment = document.createElement('script');
      segment.innerHTML = `
(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', '${environment.ga.gtm}');
        `;

      head.appendChild(segment);
    }
  }

  zendeskSetup() {
    if (!window['zE']) {
      return;
    }

    window['zESettings'] = {
      webWidget: {
        chat: {
          departments: {
            enabled: ['Vendors'],
            select: ['Vendors']
          }
        },
        launcher: {
          mobile: {
            labelVisible: false
          }
        }
      }
    };
  }

  identify(user: any = {}) {
    if (!window['zE']) {
      return;
    }

    if (user.vendorName) {
      user.organization = user.vendorName;
      delete user.vendorName;
    }

    if (environment.segment.enabled) {
      analytics.identify(user._id, {
        ...user,
        email: user.email,
        age: user.age,
        gender: user.gender,
        birthday: user.birthDate,
        first_name: user.name,
        phone: user.mobileNumber,
        company: user.companyName,
        address: user.address,
        createdAt: user.createdAt
      }, {});
    }

    window['zE'](function() {
      window['zE']('webWidget', 'prefill', {
        name: {
          value: user.name,
          readOnly: true // optional
        },
        email: {
          value: user.email,
          readOnly: true // optional
        },
        phone: {
          value: user.phoneNumber,
          readOnly: true // optional
        }
      });
      window['zE']('webWidget', 'identify', user);
    });

    if (window['amplitude']) {
      window['amplitude'].setUserId(user._id);
      window['amplitude'].setUserProperties({
        ...user,
        email: user.email,
        age: user.age,
        gender: user.gender,
        birthday: user.birthDate,
        first_name: user.name,
        phone: user.mobileNumber,
        company: user.companyName,
        address: user.address,
        createdAt: user.createdAt
      });
    }
  }

  logout() {

    if (window['amplitude']) {
      window['amplitude'].setUserId(null);
      window['amplitude'].clearUserProperties();
    }
    if (!window['zE']) {
      return;
    }

    window['zE'](function() {
      window['zE']('webWidget', 'logout');
    });
  }

  page(title: string) {
    if (!window) return;
    if (environment.segment.enabled) {
      analytics.page(title);
    }

    if (window['amplitude']) {
      window['amplitude'].logEvent(title);
    }
  }

  track(event: string, options = {}) {
    if (!window) return;
    if (environment.segment.enabled) {
      analytics.track(event, options);
    }

    if (window['amplitude']) {
      window['amplitude'].logEvent(event, options);
    }
  }

  hideChat() {
    if (window['zE'] && typeof window['zE'].hide === 'function') {
      window['zE'].hide();
    }
  }

  showChat() {
    if (window['zE'] && typeof window['zE'].show === 'function') {
      window['zE'].show();
    }
  }

  ngOnInit(): void {
    if (!window['amplitude']) return;
    if (window['amplitude']) {
      window['amplitude'].setLogLevel('INFO');
    }
  }
}
